import React, { useEffect, useRef } from 'react';

const Contact = () => {
  console.log("Contact component rendering");
  
  const socialButtonsRef = useRef([]);
  
  useEffect(() => {
    // Add animations to social buttons
    socialButtonsRef.current.forEach(button => {
      if (button) {
        const icon = button.querySelector('.social-icon i');
        
        button.addEventListener('mouseenter', () => {
          icon.classList.add('fa-bounce');
        });
        
        button.addEventListener('mouseleave', () => {
          icon.classList.remove('fa-bounce');
        });
      }
    });
    
    // Cleanup
    return () => {
      socialButtonsRef.current.forEach(button => {
        if (button) {
          const icon = button.querySelector('.social-icon i');
          
          button.removeEventListener('mouseenter', () => {
            icon.classList.add('fa-bounce');
          });
          
          button.removeEventListener('mouseleave', () => {
            icon.classList.remove('fa-bounce');
          });
        }
      });
    };
  }, []);
  
  return (
    <section id="contact" className="section contact">
      <h1 className="title">Get In Touch</h1>
      <p className="contact-intro">Feel free to reach out through any of these platforms:</p>
      
      <div className="social-links-container">
        <a 
          className="social-button" 
          href="https://github.com/thedocscripts/" 
          target="_blank" 
          rel="noopener noreferrer"
          ref={el => el && socialButtonsRef.current.push(el)}
        >
          <span className="social-icon"><i className="fa-brands fa-github"></i></span>
          <span className="social-label">Github</span>
        </a>
        <a 
          className="social-button" 
          href="mailto:enriquetair23@gmail.com" 
          target="_blank" 
          rel="noopener noreferrer"
          ref={el => el && socialButtonsRef.current.push(el)}
        >
          <span className="social-icon"><i className="fa-regular fa-envelope"></i></span>
          <span className="social-label">Email</span>
        </a>
        <a 
          className="social-button" 
          href="https://www.linkedin.com/in/enrique-cabello-6653b9233/" 
          target="_blank" 
          rel="noopener noreferrer"
          ref={el => el && socialButtonsRef.current.push(el)}
        >
          <span className="social-icon"><i className="fa-brands fa-linkedin"></i></span>
          <span className="social-label">LinkedIn</span>
        </a>
      </div>
    </section>
  );
};

export default Contact; 